import { Util } from 'cloudinary-core'

// Resolves the uploaded asset's info (secure_url, original_filename, format,
// resource_type, ...), or null when the coach closes the widget.
const uploadMedia = options =>
  new Promise((resolve, reject) => {
    const scOptions = Util.withSnakeCaseKeys(options)
    window.cloudinary.openUploadWidget(scOptions, (error, res) => {
      if (error) {
        reject(error)
      } else if (res.event === 'success') {
        resolve(res.info)
      } else if (res.event === 'close') {
        resolve(null)
      }
    })
  })

export default uploadMedia
